<template>
  <div class="favorite">
    <mbHeader :title="$t('favourites')" :lang="true"></mbHeader>
    <div class="list" v-if="!isLoading">
      <ul v-if="favoritesList.length">
        <li class="listItem" v-for="(item, index) in favoritesList" v-bind:key="index" v-if="!item.IsStopSale">
          <div class="left" @click="goToProductDetail(item)">
            <img :src="item.Thumbnail" alt="">
          </div>
          <div class="min">
            <div class="clickView" @click="goToProductDetail(item)">
              <p class="list-brand" @click="selectNewSearch(item.Brand, 'Brand')">{{ item.Brand }}</p>
              <p class="list-name">{{ curIsEnglish ? item.Name : item.Description }}</p>
              <div class="price">
                <p class="list-price-original" v-if="item.OriginalPrice">
                  ${{ item.OriginalPrice ? item.OriginalPrice.toFixed(2) : '' }}</p>
                <p class="list-price" :class="{'list-price-promo':item.OriginalPrice}">${{ item.Price ? item.Price.toFixed(2) : '' }}</p>
              </div>
            </div>
            <div class="delete" @click="deFavoriteProduct(item)">Delete</div>
          </div>
          <div class="right outOfStock" v-if="isOutOfStock(item)">{{ $t('outOfStock') }}</div>
          <div class="right" v-else @click="throttleAddToCart(item, $event)">
            <font-awesome-icon icon="shopping-cart" :style="{ color: 'white', fontSize: '15px' }"/>
          </div>
        </li>
      </ul>
      <div v-else class="continue-shopping">
        <p>{{ $t('you_havent_favorited') }}</p>
        <button @click="continueShopping">{{ $t('continueShopping') }}</button>
      </div>
    </div>

    <div v-else class="loadings">
      <img src="../../assets/img/loading.gif" alt="">
    </div>

    <recommended></recommended>

  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

import mbHeader from "../../components/mobile/mbHeader";
import {isUserAuthenticated} from "../../store/modules/cart";
import recommended from "../recommended";
import busUtil from "../../assets/js/util";
import {locales, toProductDetail} from "../../mixin";

export default {
  name: "Favorite",
  mixins: [toProductDetail, locales],
  components: {
    mbHeader,
    recommended
  },
  data() {
    return {
      favoritesList: [],
      isLoading: false,
    }
  },
  mounted() {
    this.loadFavorites();
  },
  methods: {
    ...mapActions('products', ['getFavorites', 'removeProductFromFavorites']),
    ...mapActions('cart',['addProductToCart']),
    ...mapMutations('navbar', ['toggleZipcodeModalVisibility', 'toggleWarehouseSelectionModalVisibility']),
    loadFavorites() {
      this.isLoading = true;
      this.getFavorites()
        .then(res => {
          this.isLoading = false;
          this.favoritesList = res.data;
        }, (err) => {
          this.isLoading = false;
        })
    },
    continueShopping() {
      this.$router.push('/collections');
    },
    isOutOfStock(item) {
      if (item.IsOverSaleable) {
        return false
      }
      return item.InventoryQuantity > 0 ? false : true
    },
    throttleAddToCart:  _.debounce(function(item, e) {
      e.preventDefault();
      busUtil.$emit('addToCartDrop', e, item)
      this.addThisToCart(item)
    }, 150, {'leading': true, 'trailing': true}),
    addThisToCart: function(item) {
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Pickup') {
        this.toggleWarehouseSelectionModalVisibility(true);
        return;
      }
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Delivery') {
        this.toggleZipcodeModalVisibility(true);
        return;
      }
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item])
        }
      }
    },
    handleAddToCartSuccess(payload) {
      this.$store.dispatch('cart/addCart', payload.item)
        .then(() => {
          if (isUserAuthenticated()) {
            this.$store.dispatch('cart/getCart');
          }
        });
    },
    handleAddToCartFail(product) {
      alert(`Sorry, there are only ${product.InventoryQuantity} available of ${product.Name}`);
    },

    deFavoriteProduct(item) {
      this.removeProductFromFavorites(item.Product_id)
    },
    selectNewSearch(itemBrand, type) {
      // this.$router.push(`/collections`);
      // setTimeout(() => {
      //   this.$root.selectNewSearch(itemBrand, type);
      // }, 600);
    }
  },
  computed: mapState({
    favoriteSuccess: state => state.products.favoriteSuccess,
    loggedIn: state => state.auth.loggedIn,
  }),
  watch: {
    favoriteSuccess: function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.loadFavorites();
      }
    },
    loggedIn: function(newVal, oldVal) {
      if (newVal === true) {
        this.loadFavorites();
      }
    },
  }
}
</script>

<style scoped lang="less">
@media only screen and (max-width: 768px) {
  .favorite {
    padding: 50px 16px 86px;
    min-height: 100vh;
    display: flex;
    flex-flow: column;
    .list {
      ul {
        li {
          display: flex;
          align-items: center;
          padding: 16px 0;
          border-bottom: 1px solid #f4f6f6;

          .left {
            width: 70px;
            height: 70px;
            padding: 5px;
            margin-right: 12px;
            flex-shrink: 0;
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);

            img {
              width: 100%;
            }
          }

          .min {
            font-size: 12px;
            flex: 1;
            .clickView {
              width: 100%;
            }

            .list-name {
              text-decoration: underline;
              color: #818181;
            }

            .price {
              margin: 10px 0;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              flex-direction: row-reverse;

              .list-price-original {
                //margin-bottom: 3px;
                text-align: center;
                color: #6D7278;
                font-weight: 300;
                text-decoration: line-through;
                font-style: italic;
                margin: 0 5px;
              }

              .list-price {
                text-align: center;
                color: #131e1e;
                font-weight: 600;
              }

              .list-price-promo {
                color: #fa6400;
              }
            }
            .delete{
              border: 1px solid #8ba39e;
              color: #8ba39e;
              width: 50px;
              text-align: center;
            }
          }

          .right {
            width: 30px;
            height: 30px;
            margin-left: auto;
            background-color: #E9C34B;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            flex-shrink: 0;
            &.outOfStock {
              font-size: 12px;
              width: 70px;
              text-align: center;
              background-color: transparent;
            }

            img {
              width: 100%;
            }
          }
        }
      }
    }

    .loadings{
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        width: 40%;
      }
    }

    .continue-shopping {
      display: flex;
      flex-direction: column;
      width: 100%;
      justify-content: center;
      align-items: center;
      margin-top: 100px;
      margin-bottom: 20px;
      p {
        font-family: 'Raleway';
        font-size: 14px;
        font-weight: 600;
        color: #b6b6b6;
        margin-bottom: 35px;
      }
      button {
        border-radius: 33.8px;
        border: solid 0.8px #E9C34B;
        background-color: #E9C34B;
        font-family: 'Source Sans Pro';
        font-size: 15px;
        font-weight: 600;
        text-align: center;
        color: white;
        outline: none;
        padding: 5px 10px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/Favorite.vue